import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';

export default function MobileNavigation({
  currentView,
  setCurrentView,
  currentDate,
  setCurrentDate,
  handleNavigate,
  onAddNew,
  onCreateSeries,
  enableSeries,
  enablePeople,
  enableOutlookSync,
  showPeople,
  setShowPeople,
  showProjects,
  setShowProjects,
  showOutlookSync,
  setShowOutlookSync,
  onRemoveOutlookSyncs,
  onRefresh,
  isRefreshing,
  appView,
  setAppView,
  isAdmin,
  employees,
  selectedEmployee,
  onEmployeeChange,
  currentUserName,
  enableLeave,
  showLeave,
  setShowLeave,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);
  const [showBurgerDropdown, setShowBurgerDropdown] = useState(false);
  const [showEmployeeDropdown, setShowEmployeeDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const mobileDropdownRef = useRef(null);
  const burgerDropdownRef = useRef(null);
  const employeeDropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (mobileDropdownRef.current && !mobileDropdownRef.current.contains(event.target)) {
        setShowMobileDropdown(false);
      }
      if (burgerDropdownRef.current && !burgerDropdownRef.current.contains(event.target)) {
        setShowBurgerDropdown(false);
      }
      if (employeeDropdownRef.current && !employeeDropdownRef.current.contains(event.target)) {
        setShowEmployeeDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (appView === 'form' || appView === 'presence') {
    return (
      <div className="fixed top-3 left-3 z-[2000]">
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="p-2 rounded-lg bg-white border border-gray-200 shadow-sm hover:bg-gray-50 transition-colors"
            aria-label="Menu"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          {showDropdown && (
            <div className="absolute left-0 mt-2 w-52 bg-white border border-gray-200 rounded-lg shadow-lg">
              <div className="py-1">
                <button
                  onClick={() => { setAppView('form'); setShowDropdown(false); }}
                  className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${appView === 'form' ? 'font-semibold text-[#537D5D]' : 'text-gray-700'}`}
                >
                  Log tid
                </button>
                <button
                  onClick={() => { setAppView('calendar'); setShowDropdown(false); }}
                  className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${appView === 'calendar' ? 'font-semibold text-[#537D5D]' : 'text-gray-700'}`}
                >
                  Kalender
                </button>
                {enablePeople && (
                  <button
                    onClick={() => { setAppView('presence'); setShowDropdown(false); }}
                    className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${appView === 'presence' ? 'font-semibold text-[#537D5D]' : 'text-gray-700'}`}
                  >
                    Tilstædeværelse
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Mobile Header - Fixed at top */}
      <div className="1.5xl:hidden fixed top-0 left-0 right-0 flex items-center justify-between p-3 border-b border-gray-200 bg-white z-[2000]">
        {/* Left: Hamburger Menu */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors min-h-touch-target min-w-[60px] flex items-center justify-center"
          aria-label="Menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        {/* Center: Previous + Date + Next */}
        <div className="flex items-center gap-2 flex-1 justify-center">
        {appView === 'calendar' && (<>
          <button
            onClick={() => {
              const unit = currentView === 'day' ? 'day' : currentView === 'month' ? 'month' : 'week';
              const amount = 1;
              const newDate = moment(currentDate).subtract(amount, unit).toDate();
              handleNavigate(newDate);
            }}
            className="p-2 rounded-full hover:bg-gray-100 transition-colors min-h-touch-target min-w-touch-target flex items-center justify-center"
            aria-label="Previous"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <div className="flex flex-col items-center mx-2">
            {(currentView === 'week' || currentView === 'work_week') && (
              <span className="text-xs font-medium px-2 py-0.5 bg-[#ccb778] text-white rounded-full mb-1">
                W{moment(currentDate).format('w')}
              </span>
            )}
            {currentView === 'three_day' && (
              <span className="text-xs font-medium px-2 py-0.5 bg-[#ccb778] text-white rounded-full mb-1">
                3D
              </span>
            )}
            <h2 className="text-base font-semibold text-center">
              {currentView === 'day' 
                ? moment(currentDate).format('MMM D')
                : currentView === 'three_day'
                ? (() => {
                    const start = moment(currentDate);
                    const end = moment(currentDate).add(2, 'days');
                    return start.month() === end.month() 
                      ? `${start.format('MMM D')}-${end.format('D')}`
                      : `${start.format('MMM D')} - ${end.format('MMM D')}`;
                  })()
                : moment(currentDate).format('MMM YYYY')}
            </h2>
          </div>

          <button
            onClick={() => {
              const unit = currentView === 'day' ? 'day' : currentView === 'month' ? 'month' : 'week';
              const amount = 1;
              const newDate = moment(currentDate).add(amount, unit).toDate();
              handleNavigate(newDate);
            }}
            className="p-2 rounded-full hover:bg-gray-100 transition-colors min-h-touch-target min-w-touch-target flex items-center justify-center"
            aria-label="Next"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </>)}
        </div>

        {/* Right: Add New Dropdown */}
        {appView !== 'calendar' && <div className="relative" ref={mobileDropdownRef}>
          <button
            onClick={() => setShowMobileDropdown(!showMobileDropdown)}
            className="px-5 py-2 text-xs font-bold bg-[#ccb778] text-white rounded-lg min-h-touch-target min-w-[60px] flex items-center gap-1"
          >
            Add
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          {/* Mobile Dropdown Menu */}
          {showMobileDropdown && (
            <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
              <div className="py-1">
                <button
                  onClick={() => {
                    onAddNew();
                    setShowMobileDropdown(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Ny registrering
                </button>
                {enableSeries && (
                  <button
                    onClick={() => {
                      onCreateSeries();
                      setShowMobileDropdown(false);
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-black-600 hover:bg-gray-100"
                  >
                    Ny serie
                  </button>
                )}
              </div>
            </div>
          )}
        </div>}
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="1.5xl:hidden fixed inset-0 z-[2100] bg-black bg-opacity-50 hamburger-menu-overlay" onClick={() => setIsMenuOpen(false)}>
          <div className="bg-white w-80 h-full shadow-xl" onClick={(e) => e.stopPropagation()}>
            {/* Menu Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <h3 className="text-lg font-semibold">Captivate</h3>
                <button
                  onClick={() => { onRefresh(); setIsMenuOpen(false); }}
                  disabled={isRefreshing}
                  title="Opdater kalender"
                  className="p-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50"
                >
                  <svg className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                </button>
              </div>
              <button
                onClick={() => setIsMenuOpen(false)}
                className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Menu Content */}
            <div className="p-4 space-y-6 overflow-y-auto h-[calc(100%-65px)]">
              {/* Date Navigation */}
              <div>
                <h4 className="text-sm font-bold text-gray-700 mb-3">Datonavigation</h4>
                <button
                  onClick={() => {
                    handleNavigate(new Date());
                    setIsMenuOpen(false);
                  }}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors font-medium text-left"
                >
                  I dag
                </button>
              </div>

              {/* App View Toggle */}
              <div>
                <h4 className="text-sm font-bold text-gray-700 mb-3">Visning</h4>
                <div className="flex rounded-lg border border-gray-300 overflow-hidden">
                  <button
                    onClick={() => { setAppView('form'); setIsMenuOpen(false); }}
                    className={`flex-1 px-4 py-3 text-sm font-medium ${appView === 'form' ? 'bg-[#537D5D] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                  >
                    Log tid
                  </button>
                  <button
                    onClick={() => { setAppView('calendar'); setIsMenuOpen(false); }}
                    className={`flex-1 px-4 py-3 text-sm font-medium border-l border-gray-300 ${appView === 'calendar' ? 'bg-[#537D5D] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                  >
                    Kalender
                  </button>
                  {enablePeople && (
                    <button
                      onClick={() => { setAppView('presence'); setIsMenuOpen(false); }}
                      className={`flex-1 px-4 py-3 text-sm font-medium border-l border-gray-300 ${appView === 'presence' ? 'bg-[#537D5D] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                    >
                      På arbejde
                    </button>
                  )}
                </div>
              </div>

              {/* Calendar Tab Filter */}
              {appView === 'calendar' && (enablePeople || enableLeave) && (
                <div>
                  <div className="flex rounded-lg border border-gray-300 overflow-hidden">
                    <button
                      onClick={() => { setShowProjects(true); setShowPeople(false); setShowLeave(false); setIsMenuOpen(false); }}
                      className={`flex-1 px-4 py-3 text-sm font-medium transition-colors ${showProjects && !showPeople && !showLeave ? 'bg-[#537D5D] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                    >
                      Projekter
                    </button>
                    {enablePeople && (
                      <button
                        onClick={() => { setShowPeople(true); setShowProjects(false); setShowLeave(false); setIsMenuOpen(false); }}
                        className={`flex-1 px-4 py-3 text-sm font-medium border-l border-gray-300 transition-colors ${showPeople && !showProjects && !showLeave ? 'bg-[#537D5D] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                      >
                        Arbejdstid
                      </button>
                    )}
                    {enableLeave && (
                      <button
                        onClick={() => { setShowLeave(true); setShowPeople(false); setShowProjects(false); setIsMenuOpen(false); }}
                        className={`flex-1 px-4 py-3 text-sm font-medium border-l border-gray-300 transition-colors ${showLeave ? 'bg-[#537D5D] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                      >
                        Fravær
                      </button>
                    )}
                  </div>
                </div>
              )}

            {/* View Selection */}
              <div>
                <h4 className="text-sm font-bold text-gray-700 mb-3">Vælg dato visning</h4>
                <div className="space-y-2">
                  {[
                    { key: 'month', label: 'Månedsvisning' },
                    { key: 'week', label: 'Ugevisning' },
                    { key: 'work_week', label: 'Arbejdsuge' },
                    { key: 'current_week', label: 'Nuværende uge' },
                    { key: 'day', label: 'Dagsvisning' },
                    { key: 'list', label: 'List' }
                  ].map((view) => (
                    <button
                      key={view.key}
                      onClick={() => {
                        if (view.key === 'current_week') {
                          setCurrentView('week');
                          setCurrentDate(new Date());
                        } else {
                          setCurrentView(view.key);
                        }
                        setIsMenuOpen(false);
                      }}
                      className={`w-full px-4 py-3 rounded-lg text-left transition-colors ${
                        currentView === view.key
                          ? 'bg-white border border-[#ccb778] text-[#ccb778] font-bold'
                          : 'border border-gray-300 hover:bg-gray-50'
                      }`}
                    >
                      {view.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Quick Actions */}
              {appView !== 'calendar' && (
              <div>
                <h4 className="text-sm font-bold text-gray-700 mb-3">Add new</h4>
                <div className="space-y-2">
                  <button
                    onClick={() => {
                      onAddNew();
                      setIsMenuOpen(false);
                    }}
                    className="w-full px-4 py-3 bg-[#ccb778] text-white rounded-lg font-medium hover:bg-[#b49646] transition-colors"
                  >
                    New entry
                  </button>
                  {enableSeries && (
                    <button
                      onClick={() => {
                        onCreateSeries();
                        setIsMenuOpen(false);
                      }}
                      className="w-full px-4 py-3 bg-[#ccb778] text-white rounded-lg font-medium hover:bg-[#b49646] transition-colors"
                    >
                      New series
                    </button>
                  )}
                </div>
              </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Desktop Navigation - Fixed at top */}
      <div className="hidden 1.5xl:flex fixed top-0 left-0 right-0 items-center justify-between gap-4 p-4 border-b border-gray-200 bg-white z-[2000]">
        <div className="flex items-center gap-4">
          <div className="relative" ref={burgerDropdownRef}>
            <button
              onClick={() => setShowBurgerDropdown(!showBurgerDropdown)}
              className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
              aria-label="Menu"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            {showBurgerDropdown && (
              <div className="absolute left-0 mt-2 w-52 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                <div className="py-1">
                  <button
                    onClick={() => { setAppView('form'); setShowBurgerDropdown(false); }}
                    className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${appView === 'form' ? 'font-semibold text-[#537D5D]' : 'text-gray-700'}`}
                  >
                    Log tid
                  </button>
                  <button
                    onClick={() => { setAppView('calendar'); setShowBurgerDropdown(false); }}
                    className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${appView === 'calendar' ? 'font-semibold text-[#537D5D]' : 'text-gray-700'}`}
                  >
                    Kalender
                  </button>
                  {enablePeople && (
                    <button
                      onClick={() => { setAppView('presence'); setShowBurgerDropdown(false); }}
                      className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${appView === 'presence' ? 'font-semibold text-[#537D5D]' : 'text-gray-700'}`}
                    >
                      Tilstædeværelse
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
          {appView === 'calendar' && (<>
          <div className="flex items-center gap-2">
            <button
              onClick={() => {
                const unit = currentView === 'day' ? 'day' : (currentView === 'month' || currentView === 'list') ? 'month' : 'week';
                const amount = 1;
                const newDate = moment(currentDate).subtract(amount, unit).toDate();
                handleNavigate(newDate);
              }}
              className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              aria-label="Previous"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              onClick={() => {
                const unit = currentView === 'day' ? 'day' : (currentView === 'month' || currentView === 'list') ? 'month' : 'week';
                const amount = 1;
                const newDate = moment(currentDate).add(amount, unit).toDate();
                handleNavigate(newDate);
              }}
              className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              aria-label="Next"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
          <h2 className="text-xl font-semibold flex items-center gap-2">
            {(() => {
              const DA_MONTHS = ['Januar','Februar','Marts','April','Maj','Juni','Juli','August','September','Oktober','November','December'];
              const daMonth = DA_MONTHS[moment(currentDate).month()];
              return currentView === 'day'
                ? `${moment(currentDate).format('dddd, ')}${daMonth}${moment(currentDate).format(' D, YYYY')}`
                : `${daMonth} ${moment(currentDate).format('YYYY')}`;
            })()}
            {(currentView === 'week' || currentView === 'work_week') && (
              <span className={`text-sm font-normal px-2 py-0.5 rounded-full ${
                currentView === 'week' && moment(currentDate).isSame(new Date(), 'week')
                  ? 'bg-[#537D5D] text-white'
                  : 'bg-gray-100'
              }`}>
                {currentView === 'week' && moment(currentDate).isSame(new Date(), 'week')
                  ? 'Current Week'
                  : `Week ${moment(currentDate).format('w')}`}
              </span>
            )}
          </h2>
          {isAdmin && (
            <div className="relative" ref={employeeDropdownRef}>
              <button
                onClick={() => setShowEmployeeDropdown(!showEmployeeDropdown)}
                className="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 bg-white text-gray-600 hover:bg-gray-50 transition-colors"
              >
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span>{selectedEmployee ? selectedEmployee.name : (currentUserName || 'Me')}</span>
                <svg className="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {showEmployeeDropdown && (
                <div className="absolute left-0 mt-1 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                  <div className="py-1">
                    <button
                      onClick={() => { onEmployeeChange(null); setShowEmployeeDropdown(false); }}
                      className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${!selectedEmployee ? 'font-semibold text-[#537D5D]' : 'text-gray-700'}`}
                    >
                      {currentUserName || 'Me'}
                    </button>
                    <div className="border-t border-gray-100 my-1" />
                    {(employees || []).map((emp) => (
                      <button
                        key={emp.Zuid}
                        onClick={() => { onEmployeeChange(emp); setShowEmployeeDropdown(false); }}
                        className={`block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${selectedEmployee?.Zuid === emp.Zuid ? 'font-semibold text-[#537D5D]' : 'text-gray-700'}`}
                      >
                        {emp.name}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
          {/* Reset cache button — hidden, re-enable by setting showResetCache to true */}
          {false && <button
            onClick={() => {
              const base = process.env.REACT_APP_API_BASE_URL || '';
              fetch(`${base}/clear-users-cache`, { method: 'POST', credentials: 'include' }).then(() => window.location.reload());
            }}
            className="px-3 py-1 text-xs bg-yellow-100 border border-yellow-400 text-yellow-800 rounded hover:bg-yellow-200"
          >
            🔄 Reset cache
          </button>}
          </>)}

        </div>

        {(enablePeople || enableLeave) && (
          <div className="absolute left-1/2 -translate-x-1/2 flex rounded-lg border border-gray-300 overflow-hidden">
            <button
              className={`px-5 py-2 text-sm font-medium transition-colors ${showProjects && !showPeople && !showLeave ? 'bg-[#537D5D] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
              onClick={() => { setShowProjects(true); setShowPeople(false); setShowLeave(false); }}
            >
              Projekter
            </button>
            {enablePeople && (
              <button
                className={`px-5 py-2 text-sm font-medium border-l border-gray-300 transition-colors ${showPeople && !showProjects && !showLeave ? 'bg-[#537D5D] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                onClick={() => { setShowPeople(true); setShowProjects(false); setShowLeave(false); }}
              >
                Arbejdstid
              </button>
            )}
            {enableLeave && (
              <button
                className={`px-5 py-2 text-sm font-medium border-l border-gray-300 transition-colors ${showLeave ? 'bg-[#537D5D] text-white' : 'text-gray-700 hover:bg-gray-50'}`}
                onClick={() => { setShowLeave(true); setShowPeople(false); setShowProjects(false); }}
              >
                Fravær
              </button>
            )}
          </div>
        )}

        {enableOutlookSync && (
          <div className="flex items-center gap-2 ml-4">
            <button
              className={`px-6 py-2 rounded-lg border font-medium transition-colors ${
                showOutlookSync
                  ? 'bg-[#ccb778] text-white border-[#ccb778] hover:bg-[#b49646]'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
              }`}
              onClick={() => setShowOutlookSync(!showOutlookSync)}
            >
              Outlook Syncs
            </button>
            <button
              className="px-6 py-2 rounded-lg border border-red-300 bg-white text-red-600 font-medium hover:bg-red-50 transition-colors"
              onClick={onRemoveOutlookSyncs}
              title="Delete all Outlook sync events in current view"
            >
              Remove Outlook Syncs
            </button>
          </div>
        )}

        <div className="flex items-center gap-4">
          <div className="flex rounded-lg border border-gray-300 overflow-hidden">
            <button
              onClick={() => setCurrentView('month')}
              className={`px-4 py-2 text-sm font-medium ${
                currentView === 'month'
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Month
            </button>
            <button
              onClick={() => setCurrentView('week')}
              className={`px-4 py-2 text-sm font-medium border-l border-gray-300 ${
                currentView === 'week'
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Week
            </button>
            <button
              onClick={() => setCurrentView('work_week')}
              className={`px-4 py-2 text-sm font-medium border-l border-r border-gray-300 ${
                currentView === 'work_week'
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Work Week
            </button>
            <button
              onClick={() => {
                setCurrentView('week');
                setCurrentDate(new Date());
              }}
              className={`px-4 py-2 text-sm font-medium border-l border-gray-300 ${
                currentView === 'week' && moment(currentDate).isSame(new Date(), 'week')
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Current Week
            </button>
            <button
              onClick={() => setCurrentView('day')}
              className={`px-4 py-2 text-sm font-medium border-l border-gray-300 ${
                currentView === 'day'
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              Day
            </button>
            <button
              onClick={() => setCurrentView('list')}
              className={`px-4 py-2 text-sm font-medium border-l border-gray-300 ${
                currentView === 'list'
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              List
            </button>
          </div>
          {/* Refresh Button */}
          <button
            onClick={onRefresh}
            disabled={isRefreshing}
            title="Refresh timelogs"
            className="p-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50"
          >
            <svg className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
          </button>

          {/* Dropdown Button - only in form view */}
          {appView !== 'calendar' && (
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className="px-4 py-2 text-sm font-bold bg-[#ccb778] text-white rounded-lg flex items-center gap-2"
            >
              Add
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {showDropdown && (
              <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                <div className="py-1">
                  <button
                    onClick={() => {
                      onAddNew();
                      setShowDropdown(false);
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    New entry
                  </button>
                  {enableSeries && (
                    <button
                      onClick={() => {
                        onCreateSeries();
                        setShowDropdown(false);
                      }}
                      className="block w-full text-left px-4 py-2 text-sm text-black hover:bg-gray-100"
                    >
                      New series
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
          )}
        </div>
      </div>
    </>
  );
} 